import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Card } from './shared/Card';
import { Badge } from './shared/Badge';
import { TrophyIcon, UserIcon, AwardIcon } from 'lucide-react';
export const Leaderboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState('leaderboard');
  const leaderboardData = [{
    id: 1,
    name: 'AstroMaster',
    xp: 3250,
    streak: 12,
    avatar: '👨‍🚀'
  }, {
    id: 2,
    name: 'StarGazer',
    xp: 2980,
    streak: 8,
    avatar: '👩‍🔬'
  }, {
    id: 3,
    name: 'CosmicExplorer',
    xp: 2740,
    streak: 10,
    avatar: '🧑‍🚀'
  }, {
    id: 4,
    name: 'You',
    xp: 2580,
    streak: 7,
    avatar: '😎',
    isUser: true
  }, {
    id: 5,
    name: 'NebulaNomad',
    xp: 2340,
    streak: 5,
    avatar: '👨‍💻'
  }];
  const achievementData = [{
    id: 'self-explorer',
    name: 'Self Explorer',
    description: 'Complete the MBTI assessment',
    icon: '🧠',
    earned: true,
    date: '2 days ago'
  }, {
    id: 'cosmic-navigator',
    name: 'Cosmic Navigator',
    description: 'Complete your astrological chart analysis',
    icon: '✨',
    earned: true,
    date: '2 days ago'
  }, {
    id: 'skill-master',
    name: 'Skill Master',
    description: 'Complete 5 skill development modules',
    icon: '🏆',
    earned: false,
    progress: 3,
    total: 5
  }, {
    id: 'networking-pro',
    name: 'Networking Pro',
    description: 'Connect with 3 industry professionals',
    icon: '🤝',
    earned: false,
    progress: 1,
    total: 3
  }, {
    id: 'consistent-explorer',
    name: 'Consistent Explorer',
    description: 'Maintain a 7-day streak',
    icon: '🔥',
    earned: true,
    date: 'Yesterday'
  }];
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.5
  }} data-id="element-718">
      <div className="mb-6" data-id="element-719">
        <h1 className="text-2xl font-bold text-white mb-2" data-id="element-720">
          Community Progress
        </h1>
        <p className="text-[#B8C0E0]" data-id="element-721">
          See how you compare and track your achievements
        </p>
      </div>
      <div className="flex border-b border-[#3A506B] mb-6" data-id="element-722">
        <button onClick={() => setActiveTab('leaderboard')} className={`py-2 px-4 font-medium text-sm ${activeTab === 'leaderboard' ? 'text-white border-b-2 border-[#7D56F4]' : 'text-[#B8C0E0]'}`} data-id="element-723">
          Leaderboard
        </button>
        <button onClick={() => setActiveTab('achievements')} className={`py-2 px-4 font-medium text-sm ${activeTab === 'achievements' ? 'text-white border-b-2 border-[#7D56F4]' : 'text-[#B8C0E0]'}`} data-id="element-724">
          Achievements
        </button>
      </div>
      {activeTab === 'leaderboard' ? <div className="space-y-4" data-id="element-725">
          <div className="flex justify-between items-center mb-4" data-id="element-726">
            <h2 className="text-lg font-semibold flex items-center" data-id="element-727">
              <TrophyIcon size={18} className="text-[#FFD700] mr-2" data-id="element-728" />
              Top Explorers
            </h2>
            <Badge color="purple" data-id="element-729">
              <div size={14} className="mr-1" data-id="element-730" />
              Your Streak: 7 days
            </Badge>
          </div>
          {leaderboardData.map((user, index) => <motion.div key={user.id} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: index * 0.1
      }} data-id="element-731">
              <Card className={`flex items-center ${user.isUser ? 'border-[#7D56F4]' : ''}`} data-id="element-732">
                <div className="w-8 h-8 flex items-center justify-center font-bold" data-id="element-733">
                  {index + 1}
                </div>
                <div className="w-10 h-10 bg-[#1C2541] rounded-full flex items-center justify-center text-xl mr-3" data-id="element-734">
                  {user.avatar}
                </div>
                <div className="flex-1" data-id="element-735">
                  <div className="flex justify-between" data-id="element-736">
                    <span className={`font-medium ${user.isUser ? 'text-[#7D56F4]' : ''}`} data-id="element-737">
                      {user.name} {user.isUser && '(You)'}
                    </span>
                    <span className="text-[#19D3DA] font-bold" data-id="element-738">
                      {user.xp} XP
                    </span>
                  </div>
                  <div className="flex justify-between text-xs text-[#B8C0E0]" data-id="element-739">
                    <span data-id="element-740">Rank #{index + 1}</span>
                    <span className="flex items-center" data-id="element-741">
                      <div size={12} className="text-[#FF8F5E] mr-1" data-id="element-742" />
                      {user.streak} day streak
                    </span>
                  </div>
                </div>
              </Card>
            </motion.div>)}
        </div> : <div className="space-y-4" data-id="element-743">
          <div className="mb-4" data-id="element-744">
            <h2 className="text-lg font-semibold flex items-center" data-id="element-745">
              <AwardIcon size={18} className="text-[#FFD700] mr-2" data-id="element-746" />
              Career Badges
            </h2>
          </div>
          {achievementData.map((achievement, index) => <motion.div key={achievement.id} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: index * 0.1
      }} data-id="element-747">
              <Card className={`${achievement.earned ? '' : 'opacity-70'}`} data-id="element-748">
                <div className="flex" data-id="element-749">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center text-2xl mr-4 ${achievement.earned ? 'bg-gradient-to-r from-[#FFD700] to-[#FFA500]' : 'bg-[#1C2541]'}`} data-id="element-750">
                    {achievement.icon}
                  </div>
                  <div className="flex-1" data-id="element-751">
                    <div className="flex justify-between items-start" data-id="element-752">
                      <h3 className="font-medium" data-id="element-753">{achievement.name}</h3>
                      {achievement.earned && <Badge color="gold" data-id="element-754">Earned</Badge>}
                    </div>
                    <p className="text-sm text-[#B8C0E0] mb-2" data-id="element-755">
                      {achievement.description}
                    </p>
                    {achievement.earned ? <div className="text-xs text-[#B8C0E0]" data-id="element-756">
                        Earned {achievement.date}
                      </div> : <div data-id="element-757">
                        <div className="w-full bg-[#1C2541] rounded-full h-2 mb-1" data-id="element-758">
                          <div className="h-2 rounded-full bg-[#7D56F4]" style={{
                    width: `${achievement.progress / achievement.total * 100}%`
                  }} data-id="element-759"></div>
                        </div>
                        <div className="text-xs text-[#B8C0E0]" data-id="element-760">
                          Progress: {achievement.progress}/{achievement.total}
                        </div>
                      </div>}
                  </div>
                </div>
              </Card>
            </motion.div>)}
        </div>}
    </motion.div>;
};